/**
 * Module dependencies.
 */

import React from 'react';
import { ColumnsWidget } from '../form-types';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { CrudFormRender } from '../crud-form';

/**
 * `Props` type.
 */

type Props = {
  formType: 'add' | 'edit';
  name: string;
  item: ColumnsWidget;
  form: UseFormReturn<FieldValues, any>;
};

/**
 * Export `Columns` component.
 */

export function Columns({ form, item, formType }: Props): JSX.Element {
  return (
    <div
      className={'grid'}
      style={{
        columnGap: item.gutter,
        gridTemplateColumns: 'repeat(24, minmax(0, 1fr))'
      }}
    >
      {item.columns.map((column, index) => {
        return (
          <div key={index} style={{ gridColumn: `span ${column.column} / span ${column.column}`, ...column.style }}>
            <CrudFormRender form={form} formFields={column.children} formType={formType} />
          </div>
        );
      })}
    </div>
  );
}
